import styles from './ListEmptyState.module.css'

export function ListEmptyState({children}: React.PropsWithChildren) {
  return <div className={styles.emptyStateContainer}>{children}</div>
}
